export default __webpack_public_path__ + "static/media/pizza-number-3.ffe59b77.jpeg";